export default function postBackupReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'CREATE_BACKUP_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'CREATE_BACKUP_ERROR':
      return {...state, ...{error: action.error}};

    case 'CREATE_BACKUP_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}